import React, { useEffect } from 'react';

import { useIntl } from 'react-intl';

import { HomePage } from 'components/features/home-page';
import MainFabButton from 'pages/home/main-fab-button';
import { LoyaltyCtaBar } from 'pages/loyalty/loyalty-cta-bar';
import { useCustomizableContent } from 'state/customizable-content';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLocationContext } from 'state/location';
import { isMobile } from 'utils/environment';

interface ILocationState {
  triggerSignInAccessibility: string;
}

const Home = () => {
  const { location } = useLocationContext();
  const { triggerSignInAccessibility } = (location?.state || {}) as ILocationState;
  const { formatMessage } = useIntl();
  const { requestRollUpTheRimContent } = useCustomizableContent();
  const enableRutrHomePageBanner = useFlag(LaunchDarklyFlag.ENABLE_RUTR_HOME_PAGE_BANNER);
  const signInAccessibilityMsg = triggerSignInAccessibility
    ? formatMessage({ id: 'visuallyHiddenSignInSuccess' })
    : '';

  useEffect(() => {
    if (enableRutrHomePageBanner) {
      requestRollUpTheRimContent();
    }
  }, [enableRutrHomePageBanner, requestRollUpTheRimContent]);

  return (
    <div data-testid="homepage" aria-label={signInAccessibilityMsg} role="alert">
      {isMobile() && <LoyaltyCtaBar />}
      <HomePage />
      <MainFabButton />
    </div>
  );
};

export default Home;
